<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">Pre-discount Taiwan</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ส่งคูปองล่วงหน้าไป Taiwan Coupon Schedule · lot_id จาก site_ev
      </p>
      <span *ngIf="siteState.selectedSite()?.name"
        class="inline-flex items-center gap-1 mt-3 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
        <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
      </span>
      <span class="inline-flex items-center gap-1 mt-3 ml-2 px-2.5 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-500 text-xs font-bold">
        MOCK UI
      </span>
    </div>
    <div class="flex items-center gap-3">
      <button type="button" (click)="onRefresh()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-5 py-3 rounded-2xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none cursor-pointer flex items-center gap-2">
        <span class="material-icons text-[18px]">add</span>
        สร้างคำขอ
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4">
      <div class="flex flex-wrap items-center gap-1 p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl">
        <button type="button" (click)="setFilterStatus('all')"
          class="px-3 py-2 rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="filterStatus === 'all' ? 'bg-white dark:bg-slate-700 shadow-sm text-slate-700 dark:text-slate-100' : 'text-slate-400'">ทั้งหมด</button>
        <button type="button" (click)="setFilterStatus('draft')"
          class="px-3 py-2 rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="filterStatus === 'draft' ? 'bg-white dark:bg-slate-700 shadow-sm text-slate-600' : 'text-slate-400'">ร่าง</button>
        <button type="button" (click)="setFilterStatus('approved')"
          class="px-3 py-2 rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="filterStatus === 'approved' ? 'bg-white dark:bg-slate-700 shadow-sm text-green-600' : 'text-slate-400'">อนุมัติแล้ว</button>
        <button type="button" (click)="setFilterStatus('cancelled')"
          class="px-3 py-2 rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="filterStatus === 'cancelled' ? 'bg-white dark:bg-slate-700 shadow-sm text-rose-600' : 'text-slate-400'">ยกเลิก</button>
      </div>

      <div class="flex flex-col lg:flex-row gap-3">
        <select [(ngModel)]="filterSync" (ngModelChange)="setFilterSync($event)"
          class="bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl px-3 py-2.5 text-sm font-bold outline-none">
          <option value="all">Sync ทั้งหมด</option>
          <option value="not_sent">ยังไม่ส่ง</option>
          <option value="pending">กำลังส่ง</option>
          <option value="success">สำเร็จ</option>
          <option value="failed">ล้มเหลว</option>
        </select>
        <div class="relative flex-1">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()"
            placeholder="ค้นหาเลขที่ / ทะเบียน / uuid..."
            class="w-full pl-10 pr-4 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
        <button type="button" (click)="onSearch()"
          class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold cursor-pointer">ค้นหา</button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">เลขที่</th>
            <th class="p-4">ลาน / lot_id</th>
            <th class="p-4">คู่</th>
            <th class="p-4">qty / limit</th>
            <th class="p-4">สถานะ</th>
            <th class="p-4">Taiwan</th>
            <th class="p-4">uuid</th>
            <th class="p-4">วันที่</th>
            <th class="p-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngIf="!selectedSiteId && !isLoading">
            <td colspan="9" class="py-16 text-center text-slate-400 font-bold">กรุณาเลือกลานจาก Sidebar</td>
          </tr>
          <tr *ngFor="let row of rows; trackBy: trackById"
            class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 cursor-pointer"
            (click)="openView(row)">
            <td class="p-4 font-bold text-slate-700 dark:text-slate-200">{{ row.name }}</td>
            <td class="p-4">
              <div class="flex flex-col gap-0.5">
                <span class="text-xs text-slate-600 dark:text-slate-300">{{ row.siteName }}</span>
                <span class="text-[11px] font-mono text-slate-400">{{ row.lotId }}</span>
              </div>
            </td>
            <td class="p-4 text-xs">{{ row.detailCount }}</td>
            <td class="p-4 text-xs font-mono">{{ row.quantity }} / {{ row.stampLimit }}</td>
            <td class="p-4">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold border"
                [ngClass]="{
                  'bg-slate-50 text-slate-600 border-slate-200': row.status === 'draft',
                  'bg-amber-50 text-amber-700 border-amber-200': row.status === 'pending_approval',
                  'bg-green-50 text-green-700 border-green-200': row.status === 'approved',
                  'bg-rose-50 text-rose-700 border-rose-200': row.status === 'rejected' || row.status === 'cancelled'
                }">{{ statusLabel(row.status) }}</span>
            </td>
            <td class="p-4">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold border"
                [ngClass]="{
                  'bg-slate-50 text-slate-500 border-slate-200': row.taiwanSyncStatus === 'not_sent',
                  'bg-sky-50 text-sky-700 border-sky-200': row.taiwanSyncStatus === 'pending',
                  'bg-green-50 text-green-700 border-green-200': row.taiwanSyncStatus === 'success',
                  'bg-amber-50 text-amber-700 border-amber-200': row.taiwanSyncStatus === 'failed'
                }">{{ syncLabel(row.taiwanSyncStatus) }}</span>
            </td>
            <td class="p-4 font-mono text-[11px] text-slate-400" [title]="row.taiwanScheduleUuid || ''">{{ shortUuid(row.taiwanScheduleUuid) }}</td>
            <td class="p-4 text-xs whitespace-nowrap">{{ row.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="p-4 text-center" (click)="$event.stopPropagation()">
              <button type="button" (click)="openView(row)"
                class="inline-flex w-8 h-8 items-center justify-center rounded-lg text-slate-500 bg-slate-50 hover:bg-amber-400 hover:text-white cursor-pointer"
                title="ดู">
                <span class="material-icons text-[18px]">visibility</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading && rows.length === 0">
            <td colspan="9" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">ไม่พบคำขอ</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Modal -->
<div *ngIf="isModalOpen" class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
  (click)="closeModal()">
  <div class="relative w-full max-w-4xl max-h-[90vh] overflow-y-auto bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-700"
    (click)="$event.stopPropagation()">
    <div class="absolute top-0 left-[10%] w-[80%] h-1.5 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 rounded-b-full"></div>
    <div *ngIf="isSaving" class="absolute inset-0 z-50 bg-white/70 dark:bg-slate-900/70 flex items-center justify-center">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="px-6 md:px-8 pt-8 pb-4 border-b border-slate-100 dark:border-slate-700 flex items-start justify-between gap-4">
      <div>
        <h2 class="text-xl font-extrabold text-slate-800 dark:text-slate-100">
          {{ modalMode === 'create' ? 'สร้างคำขอ Pre-discount' : (modalMode === 'edit' ? 'แก้ไขคำขอ' : 'รายละเอียดคำขอ') }}
        </h2>
        <p *ngIf="selected" class="text-xs text-slate-400 mt-1 font-mono">{{ selected.name }}</p>
      </div>
      <button type="button" (click)="closeModal()" class="p-2 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer">
        <span class="material-icons text-slate-400">close</span>
      </button>
    </div>

    <div class="px-6 md:px-8 py-6 space-y-6">
      <!-- View header -->
      <div *ngIf="modalMode === 'view' && selected" class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div>
          <div class="text-xs font-bold text-slate-400 mb-1">สถานะ</div>
          <div class="font-bold">{{ statusLabel(selected.status) }} · {{ syncLabel(selected.taiwanSyncStatus) }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 mb-1">taiwan_schedule_uuid (ห้ามแก้)</div>
          <div class="flex items-center gap-2">
            <code class="text-xs break-all text-slate-600 dark:text-slate-300">{{ selected.taiwanScheduleUuid || '—' }}</code>
            <button *ngIf="selected.taiwanScheduleUuid" type="button" (click)="copyUuid()"
              class="p-1 rounded-lg hover:bg-slate-100 cursor-pointer" title="คัดลอก">
              <span class="material-icons text-[16px] text-slate-400">content_copy</span>
            </button>
          </div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 mb-1">lot_id (site_ev)</div>
          <div class="font-mono text-xs">{{ selected.lotId }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 mb-1">rule_uuid / qty / limit</div>
          <div class="font-mono text-xs break-all">{{ selected.ruleUuid }} · {{ selected.quantity }} / {{ selected.stampLimit }}</div>
        </div>
      </div>

      <!-- Form -->
      <div *ngIf="modalMode !== 'view'" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">rule_uuid</label>
            <input type="text" [(ngModel)]="form.ruleUuid" [disabled]="selected?.status === 'approved'"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60" />
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="block text-xs font-bold text-slate-500 mb-2">quantity</label>
              <input type="number" [(ngModel)]="form.quantity" min="1" [disabled]="selected?.status === 'approved'"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 outline-none disabled:opacity-60" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-500 mb-2">limit</label>
              <input type="number" [(ngModel)]="form.stampLimit" min="1"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 outline-none" />
            </div>
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-2">หมายเหตุ</label>
          <textarea [(ngModel)]="form.requestRemark" rows="2"
            class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 outline-none"></textarea>
        </div>
      </div>

      <!-- Details table -->
      <div>
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">คู่ทะเบียน / วันที่</h3>
          <button *ngIf="modalMode !== 'view'" type="button" (click)="addDetailRow()"
            class="text-xs font-bold text-amber-600 hover:text-amber-700 cursor-pointer flex items-center gap-1">
            <span class="material-icons text-[16px]">add</span> เพิ่มแถว
          </button>
        </div>
        <div class="rounded-xl border border-slate-100 dark:border-slate-700 overflow-hidden">
          <table class="w-full text-left text-sm">
            <thead class="bg-slate-50 dark:bg-slate-800 text-xs text-slate-400">
              <tr>
                <th class="p-3 w-12">#</th>
                <th class="p-3">ทะเบียน</th>
                <th class="p-3">วันที่</th>
                <th *ngIf="modalMode !== 'view'" class="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="modalMode === 'view' && selected">
                <tr *ngFor="let d of selected.details" class="border-t border-slate-50 dark:border-slate-700">
                  <td class="p-3 text-slate-400">{{ d.sequence }}</td>
                  <td class="p-3 font-mono">{{ d.licensePlate }}</td>
                  <td class="p-3 font-mono">{{ d.stampDate }}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="modalMode !== 'view'">
                <tr *ngFor="let d of form.details; let i = index" class="border-t border-slate-50 dark:border-slate-700">
                  <td class="p-3 text-slate-400">{{ i }}</td>
                  <td class="p-3">
                    <input type="text" [(ngModel)]="d.licensePlate"
                      class="w-full px-3 py-2 rounded-lg bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 outline-none" />
                  </td>
                  <td class="p-3">
                    <input type="date" [(ngModel)]="d.stampDate"
                      class="w-full px-3 py-2 rounded-lg bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 outline-none" />
                  </td>
                  <td class="p-3">
                    <button type="button" (click)="removeDetailRow(i)" class="text-rose-400 hover:text-rose-600 cursor-pointer">
                      <span class="material-icons text-[18px]">delete</span>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Logs -->
      <div *ngIf="modalMode === 'view' && selected?.logs?.length">
        <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-200 mb-3">ประวัติส่ง Taiwan</h3>
        <div class="space-y-2">
          <div *ngFor="let log of selected!.logs"
            class="rounded-xl border border-slate-100 dark:border-slate-700 px-4 py-3 text-xs">
            <div class="flex flex-wrap gap-3 font-bold text-slate-600 dark:text-slate-300">
              <span>#{{ log.attemptNo }}</span>
              <span>{{ log.triggerType }}</span>
              <span>{{ log.status }}</span>
              <span *ngIf="log.httpStatusCode">HTTP {{ log.httpStatusCode }}</span>
              <span *ngIf="log.durationMs">{{ log.durationMs }} ms</span>
            </div>
            <div class="mt-1 font-mono text-slate-400 break-all">{{ log.endpointUrl }}</div>
            <div *ngIf="log.errorMessage" class="mt-1 text-rose-500">{{ log.errorMessage }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-700 flex flex-wrap justify-between gap-3">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-wrap justify-end gap-3 ml-auto">
      <button type="button" (click)="closeModal()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-500 cursor-pointer">ปิด</button>

      <ng-container *ngIf="modalMode === 'view' && selected">
        <button *ngIf="canEdit && selected.status === 'draft'" type="button" (click)="openEdit(selected)"
          class="px-4 py-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 font-bold cursor-pointer">แก้ไข</button>
        <button *ngIf="canEdit && selected.status === 'draft'" type="button" (click)="submitSelected()"
          class="px-4 py-2.5 rounded-xl bg-amber-400 text-white font-bold cursor-pointer">ส่ง (approve + Taiwan)</button>
        <button *ngIf="canEdit && selected.status === 'approved' && selected.taiwanScheduleUuid" type="button" (click)="openEdit(selected)"
          class="px-4 py-2.5 rounded-xl bg-sky-500 text-white font-bold cursor-pointer">แก้คู่ทะเบียน (PUT)</button>
        <button *ngIf="canEdit && selected.status === 'approved' && !selected.taiwanScheduleUuid" type="button" (click)="retrySelected()"
          class="px-4 py-2.5 rounded-xl bg-violet-500 text-white font-bold cursor-pointer">Retry POST</button>
        <button *ngIf="canDelete && selected.status !== 'cancelled' && selected.status !== 'rejected'" type="button" (click)="cancelSelected()"
          class="px-4 py-2.5 rounded-xl bg-rose-500 text-white font-bold cursor-pointer">ยกเลิก</button>
      </ng-container>

      <ng-container *ngIf="modalMode === 'create'">
        <button type="button" (click)="save(false)" class="px-4 py-2.5 rounded-xl border border-slate-200 font-bold cursor-pointer">บันทึกร่าง</button>
        <button type="button" (click)="save(true)" class="px-4 py-2.5 rounded-xl bg-amber-400 text-white font-bold cursor-pointer">สร้างและส่ง</button>
      </ng-container>

      <ng-container *ngIf="modalMode === 'edit'">
        <button type="button" (click)="save(false)" class="px-4 py-2.5 rounded-xl bg-amber-400 text-white font-bold cursor-pointer">บันทึก</button>
      </ng-container>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && selected?.id"
  [entityType]="activityEntityTypes.PrestampTaiwan"
  [entityId]="selected!.id!"
  title="ประวัติ Prestamp Taiwan"
  [subtitle]="'#' + selected!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
